import React from 'react'
import { formatCurrenctyWithoutSignal } from 'utils'
import { useFirebaseEvent } from 'hooks'
import { STATICS } from 'statics'
import { FIREBASE_EVENTS } from 'app-constants'
import './style.scss'

export function StoreCard({ product = {}, onAddItem }) {
  const { familyName: name, minValue: price, banner, options } = product
  const { sendEvent } = useFirebaseEvent()

  function handleAddItemClick() {
    const eventLabel = `${FIREBASE_EVENTS.SOFTBUNDLE_SEE_PRODUCT_DETAIL.label} ${name}`

    sendEvent({ ...FIREBASE_EVENTS.SOFTBUNDLE_SEE_PRODUCT_DETAIL, label: eventLabel })
    onAddItem(product)
  }

  function renderPriceText() {
    const hasMoreThanOneItem = options.length > 1

    if (!hasMoreThanOneItem) return null

    return (
      <>
        À partir de <br />
      </>
    )
  }

  function renderButton() {
    return (
      <button type='button' className='button' onClick={handleAddItemClick}>
        Ver detalhes <STATICS.ARROW_NEXT_STORE />
      </button>
    )
  }

  return (
    <div className='store-container-card'>
      <div className='container-banner'>
        <img className='image' alt={`Imagem do produto ${name}`} src={banner} />
      </div>
      <div className='container-info'>
        <div className='container-title'>
          <span className='title'>{name}</span>
        </div>
        <div className='container-price'>
          <span className='price'>
            {renderPriceText()}
            <span className='container-value'>
              R$
              <span className='value'>{formatCurrenctyWithoutSignal(price)}</span>/mês
            </span>
          </span>
        </div>
      </div>
      <div className='container-actions'>{renderButton()}</div>
    </div>
  )
}
